export default {

  getToken() {
    return localStorage.getItem('default_auth_token')
  },

  deleteToken() {
    return localStorage.removeItem('default_auth_token')
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.js